
import { useNotificationSettings } from "@/hooks/useNotificationSettings";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, Settings, RefreshCw } from "lucide-react";
import { NotificationSettingsTable } from "./NotificationSettingsTable";
import { NotificationSettingsLoading } from "./NotificationSettingsLoading";
import { NotificationSettingsEmpty } from "./NotificationSettingsEmpty";
import { NotificationSettingsHeader } from "./NotificationSettingsHeader";

export const NotificationSettingsManagement = () => {
  const { data: settings, isLoading, error, isError, refetch } = useNotificationSettings();

  if (isError) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription className="flex items-center justify-between">
          <span>
            حدث خطأ أثناء تحميل إعدادات الإشعارات: {error?.message || 'خطأ غير معروف'}
          </span>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => refetch()}
            className="mr-2"
          >
            <RefreshCw className="w-4 h-4 mr-1" />
            إعادة المحاولة
          </Button>
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings className="h-5 w-5" />
          إدارة إعدادات الإشعارات
        </CardTitle>
        <CardDescription>
          تخصيص قواعد إرسال الإشعارات التلقائية بناءً على حالة العميل. يتم الحفظ تلقائياً بعد التعديل.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <NotificationSettingsLoading />
        ) : (
          <>
            <NotificationSettingsHeader 
              settingsCount={settings?.length || 0}
              onRefresh={() => refetch()}
            />
            
            {settings && settings.length > 0 ? (
              <NotificationSettingsTable settings={settings} />
            ) : (
              <NotificationSettingsEmpty />
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};
